export default "__VITE_ASSET__hsftDpCQ__"